import { useState } from "react";
import { Header } from "@/components/ui/header";
import { InputPanel } from "@/components/calculator/input-panel";
import { OutputPanel } from "@/components/calculator/output-panel";
import { ErrorBoundary } from "@/components/error-boundary";
import { useResultStore } from "@/lib/resultStore";
import { type CalculationResult } from "@/types/calculator";

export default function Home() {
  const { result, isCalculating, setResult, setIsCalculating, clearResult } = useResultStore();
  const [sessionRows, setSessionRows] = useState<Record<string, string | number>[]>([]);

  const handleCalculationComplete = (calculationResult: CalculationResult) => {
    setResult(calculationResult);
    if (calculationResult.exportRow) {
      setSessionRows((prev) => [...prev, calculationResult.exportRow!]);
    }
    setIsCalculating(false);
  };

  const handleCalculationStart = () => {
    setIsCalculating(true);
  };

  const handleCalculationError = () => {
    clearResult();
    setIsCalculating(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8 min-h-[calc(100vh-200px)]">
          <div className="w-1/3">
            <InputPanel
              onCalculationStart={handleCalculationStart}
              onCalculationComplete={handleCalculationComplete}
              onCalculationError={handleCalculationError}
              isCalculating={isCalculating}
              result={result}
            />
          </div>
          <div className="w-2/3">
            <ErrorBoundary resetKey={result}>
              <OutputPanel
                result={result}
                isCalculating={isCalculating}
                sessionRows={sessionRows}
              />
            </ErrorBoundary>
          </div>
        </div>
      </main>
    </div>
  );
}